<template>
  <section class="PersonalDetail_basic" data-scroll="personalDetail">
    <div class="PersonalDetail_header flex-between">
      <h3 class="form_title">{{ $t('myaccount.personalDetail.title', 'Contact') }}</h3>
      <app-edit-button
        :editable="false"
        @click.native="goProfilePage"
        data-name="myAccountPersonalDetail-editButton"
      />
    </div>
    <div class="PersonalDetail_body MyAccountForm">
      <app-text-input
        :label="$t('myaccount.personalDetail.textLabel.firstName', 'First name')"
        v-model.trim="firstName"
        disabled
        data-name="myAccountPersonalDetail-firstName"
        autocomplete="given-name"
        name="myAccountPersonalDetail-firstName"
      />
      <app-text-input
        :label="$t('myaccount.personalDetail.textLabel.lastName', 'Last name')"
        v-model.trim="lastName"
        disabled
        data-name="myAccountPersonalDetail-lastName"
        autocomplete="family-name"
        name="myAccountPersonalDetail-lastName"
      />
      <app-text-input
        type="email"
        :label="$t('myaccount.personalDetail.textLabel.email', 'Email')"
        v-model.trim="email"
        disabled
        data-name="myAccountPersonalDetail-email"
        autocomplete="email"
        name="myAccountPersonalDetail-email"
      />
      <app-text-input
        type="tel"
        :label="$t('myaccount.personalDetail.textLabel.phoneNumber', 'Telephone number')"
        v-model.trim="phoneNumber"
        disabled
        data-name="myAccountPersonalDetail-phoneNumber"
        autocomplete="tel"
        name="myAccountPersonalDetail-phoneNumber"
      />
      <!-- <extra-optin-note class="ExtraOptinNote" :content="$t('common.personalDetail.newsletterNote', '')" />
      <app-checkbox
        id="newsletter"
        :label="$t('common.personalDetail.newsletter', 'Philips may send me personalized news and offers. You can log out easily and at any time.')"
        :value="selectedNewsletter"
        disabled
      >
        <a
          class="link"
          target="_blank"
          :href="$t('common.personalDetail.newsletter.linkUrl', '##')">{{ $t('common.personalDetail.newsletter.linkText', 'What does this mean?') }}
        </a>
      </app-checkbox> -->
    </div>
  </section>
</template>

<script>
  import PersonalDetailMixin from 'mixins/personal-detail'
  import ExtraOptinNote from 'components/ExtraOptinNote'

  export default {
    name: 'my-account-personal-detail',

    components: {
      ExtraOptinNote
    },

    mixins: [PersonalDetailMixin],

    methods: {
      async goProfilePage () {
        await this.$udiAuth.redirectToProfile()
      }
    }
  }
</script>

<style lang="scss">
.MyAccountPage_PersonalDetail {
  .MyAccountForm {
    .Form_group-choice {
      margin-top: 0.1rem;
    }

    input {
      &.Form_control:disabled {
        -webkit-text-fill-color: $gray;
        color: $gray;
      }
    }

    .ExtraOptinNote {
      padding-left: .15rem;
      margin-top: .15rem;
    }
  }
}
</style>
